module.exports = __webpack_public_path__ + "img/result copy.c526d9d3.jpg";